<template>
  <div
    class="strip map_view add_top_20"
    :class="availableStore"
  >
    <div
      class="row no-gutters"
      style="cursor: pointer"
      @click="clickStore()"
    >
      <div class="col-4">
        <figure class="dark-background">
          <a>
            <StoreImages
              :store="store"
              :img-class="'img-cover'"
            />
          </a>
        </figure>
      </div>
      <div class="col-8">
        <div
          class="wrapper pt-3"
          style="min-height: 125px"
        >
          <div class="d-flex flex-column flex-lg-row justify-content-between">
            <div class="flex-grow-1">
              <span class="small">{{ $t('lang.stores.store_in').toUpperCase() }}</span>

              <h6 class="color_text">
                {{ store.name }}
              </h6>
              <StoreReputation
                v-if="store.reviews_scoring"
                :scoring="this.store.reviews_scoring"
                :reviews="store.total_reviews"
              />
              <ScheduleBadge
                :store="store"
                :search-params="searchParams"
              />
            </div>

            <div
              v-if="store.is_locker"
              class="mt-0 mt-n1 text-lg-right mb-0"
            >
              <span class="badge badge-pill badge-warning badge-padding">
                <i class="fas fa-lock" />&nbsp;&nbsp; {{ $t('lang.lockers.badge') }}
              </span>
              <p class="small mt-0 mb-0">
                {{ $t('lang.lockers.price_from') }} <br class="d-none d-lg">

                <span v-if="useHourly">
                  <b>${{ parseInt(store.lockers[0].price_lists[0].price_per_hour) }}
                    {{ store.lockers[0].price_lists[0].currency }} /
                    <small> {{ $tc('lang.lockers.price_per_hour', 1) }}</small>
                  </b>
                </span>
                <span v-else>
                  <b>${{ parseInt(store.lockers[0].price_lists[0].price_per_day) }}
                    {{ store.lockers[0].price_lists[0].currency }} /
                    <small> {{ $tc('lang.lockers.price_per_day', 1) }} </small>
                  </b>
                </span>
              </p>
            </div>
          </div>
        </div>

        <!--          BOTTOM / CARD FOOTER -->
        <div style="bottom: 0">
          <ul>
            <li>
              <WalkingDistance
                v-if="order==='distance'"
                :distance-in-km="store.distance"
              />
              <span v-else>
                <i class="fa-solid fa-location-dot" /> {{ store.address_zone }}
              </span>
            </li>

            <li>
              <b-link
                class=""
                href="#"
                @click="clickStore()"
              >
                {{ $t('lang.stores.see_on_map') }}
              </b-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment';
import StoreImages from '@/components/Store/StoreImages';
import WalkingDistance from '@/components/Store/WalkingDistance.vue';
import ScheduleBadge from '@/components/Store/ScheduleBadge.vue';
import StoreReputation from '@/components/Store/StoreReputation.vue';

export default {
  name: 'StoreCardComponent',

  components: {
    StoreReputation,
    ScheduleBadge,
    WalkingDistance,
    StoreImages,
  },

  props: {
    store: {
      type: Object,
      required: true,
    },
    searchParams: {
      type: Object,
      required: false,
    },
    order: {
      type: String,
      required: false,
    },
  },

  data() {
    return {};
  },

  computed: {
    availableStore() {
      if (!this.store.isAvailable) {
        return 'not-available-store';
      }
      return null;
    },
    useHourly() {
      const smallestLocker = this.store.lockers[0].price_lists[0];

      const start = moment(this.searchParams.input_start_date);
      const end = moment(this.searchParams.input_end_date);

      // Horas totales - redondeo para arriba
      const durationInHours = Math.ceil(moment.duration(end.diff(start)).asHours());

      const hourlyPrice = smallestLocker.price_per_hour * durationInHours;
      const dailyPrice = smallestLocker.price_per_day;

      return hourlyPrice < dailyPrice;
    },
  },
  methods: {
    clickStore() {
      this.$emit('selectedStoreCard', this.store, 'card');
    },
  },
};

</script>

<style scoped>
ul {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

li {
  display: flex;
  align-items: center;
  font-size: .85rem;
  line-height: .85rem;
}
li span {
  font-size: .85rem; line-height: .85rem;
}

li i {
  margin-right: 4px;
  line-height: .85;
}
</style>
